import { Injectable } from '@angular/core';
import { Router, ActivatedRoute, Params, NavigationEnd } from '@angular/router';
import * as lodash from 'lodash';
import { filter } from 'rxjs/operators';

const hasValue = (val: any) => val !== undefined && val !== null;
const filterObjectValues = (obj: object) => lodash.pickBy(obj, hasValue);

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  previousUrl: string = null;
  currentUrl: string = null;
  savedBackUrl: string = null;

  constructor(private router: Router, private activatedRoute: ActivatedRoute) {
    this.router.events
      .pipe(filter((event: any) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
      });
  }

  updateQueryParams(name: string, params: any, merge: boolean = true): void {
    const queryParams = {
      [name]: typeof params === 'object' ? JSON.stringify(filterObjectValues(params)) : params
    };

    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams,
      replaceUrl: true,
      ...(merge && { queryParamsHandling: 'merge' })
    });
  }

  getQueryParams(name: string): Params {
    const params = this.activatedRoute.snapshot.queryParams;

    try {
      return JSON.parse(params[name]);
    } catch {
      return params[name];
    }
  }

  saveBackUrl(backUrl?: string): void {
    this.savedBackUrl = backUrl || this.previousUrl;
  }

  goBack(fallbackUrl?: string): void {
    if (this.savedBackUrl && this.savedBackUrl.includes(fallbackUrl)) {
      this.router.navigateByUrl(this.savedBackUrl);
    } else {
      this.router.navigateByUrl(fallbackUrl);
    }
  }
}
